import React from 'react'

const OurWork = () => {
  return (
    <div>OurWork</div>
  )
}

export default OurWork